module.exports = __webpack_public_path__ + "img/zh_manager.2dce06cd.png";